import React, {useState, useTransition} from 'react';
import { SvgIcon } from '@mui/material';

const Stopcon = ({ isGreen, onClick, ...props }) => {
    const [isPressed, setIsPressed] = useState(false);  // State to track if the button is being pressed
    const [isPending, startTransition] = useTransition();

    const handleMouseDown = () => {
        setIsPressed(true);  // Set pressed state
    };

    const handleMouseUp = () => {
        setIsPressed(false);  // Remove pressed state
        onClick();  // Trigger the color toggle
    };
    // Function to handle mouse and touch press
    const handlePressDown = () => {
        setIsPressed(true);  // Set pressed state
    };

    const handlePressUp = () => {
        setIsPressed(false);  // Remove pressed state

        // Defer the color toggle to prioritize UI rendering
        startTransition(() => {
            onClick();  // Trigger the color toggle with lower priority
        });
    };
    return (
        <SvgIcon
            {...props}
            viewBox="0 0 24 24"
            sx={{
                padding: 0,                // Remove extra padding around the button content
                margin: 0,                 // Ensure no extra margins
                marginTop: '6px',                 // Ensure no extra margins
                marginRight: '17px',
                fontSize: '27px',
                display: 'flex',            // Flexbox to align icon center
                alignItems: 'center',       // Vertically center icon
                justifyContent: 'center',   // Horizontally center icon
                border: 'none',
                boxShadow: 'none',
                cursor: 'pointer',
                transform: isPressed ? 'scale(0.8)' : 'scale(1)',  // More pronounced shrink when pressed
                transition: 'transform 0.2s ease-in-out',  // Smooth transition for shrinking
                /*opacity: isPending ? 0.7 : 1,  // Optionally fade slightly during transition*/
            }}
            onMouseDown={handlePressDown}  // Mouse press down
            onMouseUp={handlePressUp}      // Mouse release
            onMouseLeave={() => setIsPressed(false)}  // Remove pressed state if mouse leaves
            onTouchStart={handlePressDown}  // Handle touch press for mobile devices
            onTouchEnd={handlePressUp}      // Handle touch release for mobile devices
        >
            {/* Background circle with a lighter gradient for the traffic light effect */}
            <defs>
                <radialGradient id="gradGreen" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" style={{stopColor: '#99FF99', stopOpacity: 1}}/>
                    {/* Softer green */}
                    <stop offset="100%" style={{stopColor: '#66CC66', stopOpacity: 1}}/>
                    {/* Slightly darker soft green */}
                </radialGradient>
                <radialGradient id="gradRed" cx="50%" cy="50%" r="50%">
                    {/* More white in the center and softer red on the edges */}
                    <stop offset="0%" style={{stopColor: '#FFDDDD', stopOpacity: 1}}/>
                    {/* Even lighter pinkish red */}
                    <stop offset="50%" style={{stopColor: '#FFCCCC', stopOpacity: 1}}/>
                    {/* Softer pinkish red */}
                    <stop offset="100%" style={{stopColor: '#FF9999', stopOpacity: 1}}/>
                    {/* Soft red */}
                </radialGradient>
            </defs>

            {/* Circle with consistent shrink effect on both color changes */}
            <circle
                cx="12"
                cy="12"
                r="10"
                fill={isGreen ? 'url(#gradGreen)' : 'url(#gradRed)'}  // Apply lighter gradient based on color
                stroke="none"  // No border
            />
        </SvgIcon>
    );
};

export default Stopcon;